import React from 'react';
import HeroSection from '../Components/Sections/HeroSection';
import Categories from '../Components/Sections/Categories';
import About from '../Components/Sections/About';
import OurMenu from '../Components/Sections/OurMenu';
import Video from '../Components/Sections/Video';
import FeedBack from '../Components/Sections/FeedBack';
import Team from '../Components/Sections/Team';
import BlogPost from '../Components/Sections/BlogPost';

export default function Home() {
  return (
    <>
      {/* <TopMenu /> */}
      <HeroSection/>
      <Categories/>
      <About/>
      <OurMenu/>
      <Video/>
      <Team/>
      <FeedBack/>
      <BlogPost/>
    </>
  )
}
